<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {

  },
  mounted () {
  }
}
</script>

<style scoped>
.app-main {
  /* 50 = navbar
  min-height: calc(100vh - 56px);
  position: relative;
  overflow: hidden;
  background: #f0f3f5; */
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue